import BusinessInfo from './BusinessInfo';

export default BusinessInfo;
